import { useState, useEffect } from 'react'
import { getConsent, acceptConsent, rejectConsent } from '../utils/consentManager'

export default function CookieBanner({ onManage }) {
  const [visible, setVisible] = useState(false)
  const [showManage, setShowManage] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // Set mobile state safely after mount
    setIsMobile(window.innerWidth < 768)
    
    const consent = getConsent()
    if (!consent) {
      // No decision yet - show banner
      setVisible(true)
    }
  }, [])

  // Allow external trigger to reopen
  useEffect(() => {
    if (onManage) {
      setShowManage(true)
      setVisible(true)
    }
  }, [onManage])

  const handleAccept = () => {
    acceptConsent()
    setVisible(false)
  }

  const handleReject = () => {
    rejectConsent()
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: '#1C2126',
      padding: isMobile ? '0.75rem 1rem' : '1rem 1.5rem',
      boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.5)',
      animation: 'slideUp 0.3s ease-out'
    }}>
      <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
      
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: isMobile ? 'row' : 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: isMobile ? '0.75rem' : '1.5rem'
      }}>
        {/* Text Content */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {!isMobile && (
            <h3 style={{
              color: 'white',
              fontSize: '0.875rem',
              fontWeight: '600',
              marginBottom: '0.25rem',
              fontFamily: 'var(--font-display)',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}>
              🍪 Uso de Cookies
            </h3>
          )}
          <p style={{
            color: 'rgba(255, 255, 255, 0.9)',
            fontSize: isMobile ? '0.75rem' : '0.8125rem',
            lineHeight: '1.4',
            margin: 0,
            fontFamily: 'var(--font-ui)'
          }}>
            {isMobile ? (
              <>
                🍪 Usamos cookies para mejorar tu experiencia.{' '}
                <a 
                  href="/legal" 
                  style={{ 
                    color: '#3675CF', 
                    textDecoration: 'underline',
                    fontWeight: '500'
                  }}
                  onClick={(e) => {
                    e.preventDefault()
                    window.location.href = '/legal'
                  }}
                >
                  Info
                </a>
              </>
            ) : (
              <>
                Usamos cookies para mejorar tu experiencia y analizar el tráfico.{' '}
                <a 
                  href="/legal" 
                  style={{ 
                    color: '#3675CF', 
                    textDecoration: 'underline',
                    fontWeight: '500'
                  }}
                  onClick={(e) => {
                    e.preventDefault()
                    window.location.href = '/legal'
                  }}
                >
                  Más información
                </a>
              </>
            )}
          </p>
        </div>

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          gap: isMobile ? '0.5rem' : '0.75rem',
          flexDirection: 'row',
          flexShrink: 0
        }}>
          <button
            onClick={handleReject}
            style={{
              padding: isMobile ? '0.5rem 0.875rem' : '0.625rem 1.25rem',
              background: 'transparent',
              border: '1.5px solid rgba(255, 255, 255, 0.4)',
              color: 'white',
              borderRadius: '0.375rem',
              fontSize: isMobile ? '0.75rem' : '0.8125rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              fontFamily: 'var(--font-ui)',
              whiteSpace: 'nowrap'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)'
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.6)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'transparent'
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.4)'
            }}
          >
            Rechazar
          </button>
          
          <button
            onClick={handleAccept}
            style={{
              padding: isMobile ? '0.5rem 0.875rem' : '0.625rem 1.25rem',
              background: '#3675CF',
              border: 'none',
              color: 'white',
              borderRadius: '0.375rem',
              fontSize: isMobile ? '0.75rem' : '0.8125rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              fontFamily: 'var(--font-ui)',
              boxShadow: '0 2px 8px rgba(54, 117, 207, 0.3)',
              whiteSpace: 'nowrap'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#2d5fb3'
              e.currentTarget.style.transform = 'translateY(-1px)'
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(54, 117, 207, 0.4)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#3675CF'
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(54, 117, 207, 0.3)'
            }}
          >
            {isMobile ? 'Aceptar' : 'Aceptar Cookies'}
          </button>
        </div>
      </div>
    </div>
  )
}
